module.exports = __webpack_public_path__ + "static/media/Banner-spa-2.d3900bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/best-deals/Banner-spa-2.png
// module id = 1951
// module chunks = 0